// Развилка «сеть есть → прямой запрос, сети нет → очередь» — общая для всех сущностей
// кабинета, которые правятся офлайн (фаза 3, этап B). Один код на все домены (каталог,
// персонал, ...): рассинхронизация в том, что именно считается «нет сети» против
// «сервер отказал», однажды уже стоила формы, тихо проглатывающей чужую ошибку.

import type { QueryClient } from '@tanstack/react-query';

import { NetworkError } from '@/shared/api';

/** Признак синтетической записи, возвращённой оффлайн-веткой мутации. */
export type Pending = { readonly _pending?: boolean };

/**
 * Выполнить онлайн-запрос, а при отсутствии сети — оффлайн-ветку.
 *
 * `HttpError` (сервер рассмотрел и отказал) пробрасывается: его показывает форма,
 * как и раньше. `NetworkError` — единственный повод уйти в очередь.
 */
export async function onlineOrQueued<T>(
  online: () => Promise<T>,
  queued: () => Promise<T>,
): Promise<T> {
  try {
    return await online();
  } catch (error) {
    if (error instanceof NetworkError) {
      return queued();
    }
    throw error;
  }
}

/** Инвалидация после мутации — но не на синтетический результат оффлайн-ветки. */
export function invalidateUnlessPending(
  queryClient: QueryClient,
  result: Pending | null | undefined,
  queryKey: readonly unknown[],
): void {
  if (result && result._pending) {
    // Правку ещё не видел сервер — перезапрос затёр бы оптимистичную копию
    // (и упал бы с `NetworkError`). Инвалидация произойдёт после успешного
    // флаша очереди (`useSyncEngine`).
    return;
  }
  void queryClient.invalidateQueries({ queryKey });
}
